import InfoTip from '@/components/atoms/InfoTip';

import styles from '../CreateHarvestReportModal.module.scss';

interface LabelWithHelpProps {
    children: string;
    /** Shown in a tooltip on the info icon after the label. */
    help: string;
}

export function LabelWithHelp(props: LabelWithHelpProps) {
    const { children, help } = props;

    return (
        <>
            {children}
            <InfoTip topic={children} content={help} className={styles.helpTip} />
        </>
    );
}
